import { api } from '@xtnd/web/shared/api';

export interface Template {
  id: string;
  name: string;
  type: string;
  description?: string;
}

interface TemplatesConfigResponse {
  templates?: {
    pdf?: Record<string, {
      templateId?: string;
      templateName?: string;
      name?: string;
      description?: string;
    }>;
    email?: Record<string, {
      templateId?: string;
      templateName?: string;
      name?: string;
      description?: string;
    }>;
  };
}

class TemplateApi {
  /**
   * Get templates configuration for current tenant
   * Returns all templates (PDF and Email) in a normalized format
   */
  async getTemplatesConfig(): Promise<Template[]> {
    const data = (await api.get('/templates/config')) as TemplatesConfigResponse;
    const allTemplates: Template[] = [];

    // Handle the nested object structure returned by the API
    if (data.templates) {
      // Process PDF templates
      if (data.templates.pdf && typeof data.templates.pdf === 'object') {
        Object.entries(data.templates.pdf).forEach(([templateId, template]) => {
          allTemplates.push({
            id: templateId,
            name: template.templateName || template.name || templateId,
            type: 'pdf',
            description: template.description || template.templateName || template.name,
          });
        });
      }

      // Process Email templates
      if (data.templates.email && typeof data.templates.email === 'object') {
        Object.entries(data.templates.email).forEach(([templateId, template]) => {
          allTemplates.push({
            id: templateId,
            name: template.templateName || template.name || templateId,
            type: 'email',
            description: template.description || template.templateName || template.name,
          });
        });
      }
    }

    return allTemplates;
  }
}

export const templateApi = new TemplateApi();

